
define(
	'Tavanoteam.SortManufacturer.SortManufacturer'
,   [
			'jQuery'
		,	'underscore'
		,	'Utils'
		,	'Backbone'

	]
,   function (
			jQuery
		,	_
		,	Utils
		,	Backbone
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			var environment = container.getComponent('Environment');
			var plp = container.getComponent('PLP');
			
			//Get Configuration Values
			var urlFragment = environment.getConfig('TTSortManufacturer.url');

			var self = this;
			var sortedCategories;

			if (urlFragment) {
				
				//Sort Subcategory Navigation Links in Header Menu
				var defaultCategories = SC.CONFIGURATION.navigationData;

				_.each(defaultCategories, function(category)
					{
						var categoryHref = category.href;

						if (categoryHref.indexOf(urlFragment) > -1) {

							var categories = category.categories;
							
							//Sorting Function
							var sortKey = 'text';
							self.sortCategories(categories, sortedCategories, sortKey);

						}

					});

				if (Utils.isInShopping()) {

					//Sort Subcategories in Facets.Browse.View
					this.defaultSort = SC.CONFIGURATION.categories.menu.sortBy;
					this.defaultSortSubCategories = SC.CONFIGURATION.categories.subCategories.sortBy;
					this.defaultSortSideMenu = SC.CONFIGURATION.categories.sideMenu.sortBy;

					Backbone.history.on('all', function()
					{
						
						var currentPath = Backbone.history.location.href;
	
						if (currentPath.indexOf(urlFragment) > -1) {
							SC.CONFIGURATION.categories.menu.sortBy = 'name';
							SC.CONFIGURATION.categories.subCategories.sortBy = 'name';
							SC.CONFIGURATION.categories.sideMenu.sortBy = 'name'
						}
						else {
							SC.CONFIGURATION.categories.menu.sortBy = self.defaultSort;
							SC.CONFIGURATION.categories.subCategories.sortBy = self.defaultSortSubCategories;
							SC.CONFIGURATION.categories.sideMenu.sortBy = self.defaultSortSideMenu;
						}
	
					});

					// //Sort Display Values in Facets.CategorySidebar
					plp.addToViewContextDefinition('Facets.FacetedNavigationItemCategory.View', 'displayValues', 'array', function(context)
					{

						var categoryUrl = plp.getCategoryInfo().urlfragment;
						var displayValues = context.displayValues;

						if (categoryUrl.indexOf(urlFragment) > -1) {

							var categories = context.values;
							var length = context.displayValues.length;

							//Sorting Function
							var sortKey = 'displayName';
							var sortCategories = self.sortCategories(categories, sortedCategories, sortKey);
							displayValues = sortCategories.slice(0, length);

							//Store Display Values to Context
							var newDisplayValues = [];
							context.newDisplayValues = displayValues;
							newDisplayValues.push(context);

							return displayValues;

						}

						else {
							return displayValues;
						}

					});

					// //Sort Extra Values in Facets.CategorySidebar
					plp.addToViewContextDefinition('Facets.FacetedNavigationItemCategory.View', 'extraValues', 'array', function(context)
					{

						var parentUrl = plp.getCategoryInfo().urlfragment;
						var extraValues = context.extraValues;

						if (parentUrl.indexOf(urlFragment) > -1) {

							var categories = context.values;

							//Get New Display Values
							var newDisplayValues = context.newDisplayValues;

							//Sorting Function
							var sortKey = 'displayName';
							var sortCategories = self.sortCategories(categories, sortedCategories, sortKey);

							//Get New Extra Values
							var newExtraValues = self.newExtraValues(sortCategories, newDisplayValues);

							return newExtraValues;

						}

						else {
							return extraValues;
						}

					});

				}
			}

		}

		//Sort Categories in Alphabetical Order
		,   sortCategories: function sortCategories(categories, sortedCategories, sortKey)
		{
			var sortedCategories = categories.sort(function(a, b) {
				return a[sortKey].localeCompare(b[sortKey]);
			 });

			return sortedCategories;
		}
		
		//Remove newDisplayValues from extraValues
		,   newExtraValues: function newExtraValues(categories, newDisplayValues)
		{
			var newExtraValues = categories;

			newExtraValues = newExtraValues.filter(function(el) {
				return newDisplayValues.indexOf(el) < 0;
			  } );

			return newExtraValues;
		}

	};
});
